import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MapHelperService } from '../../../services/map-helper.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { PanelLocationsService } from '../locations-map/services/Panel-Locations.service';
import { NavHeaderService } from '../shared/features/nav-menu/services/nav-header.service';
import{ PanelExternalLayerService } from '../locations-map/services/Panel-External-Layer.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { CallBackService } from '../callback/services/CallBack.service';
import { MapService } from '../shared/services/Map.service';
import { PanelMapLayerService } from '../locations-map/services/Panel-Map-Layer.service';
@Component({
  selector: 'app-unified-map',
  templateUrl: './unified-map.component.html',
  styleUrls: ['./unified-map.component.css']
})
export class UnifiedMapComponent implements OnInit{
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: true })
  viewContainerRef!: ViewContainerRef;
  
  selectedPanel: any;
  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(private mapHelperService: MapHelperService,
    private mapService: MapService,
    private navHeaderService: NavHeaderService,
    private panelExternalLayerService: PanelExternalLayerService,
    private callbackService: CallBackService,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private mapLayerService: PanelMapLayerService,
    ){
      this.mobileQuery = media.matchMedia("(min-width: 761px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
    
  }
  
  ngOnInit(){
    this.mapService.CreateMapUnique(
      this._CENTER_LAT,
      this._CENTER_LNG,
      this._CENTER_ZOOM,
      this.mapHelperService.Empty_GeoJson
    );
    this.callbackService.isNeededCallback();
    this.mapHelperService.setViewContainerRef(this.viewContainerRef);
  }

  ngAfterViewInit(): void {
    this.navHeaderService.CheckMapPaneles();
    if (!this.mobileQuery.matches) {
      this.navHeaderService.setIsLocationSelected(true);
    }
  }

  ngOnDestroy(): void {
    this.panelExternalLayerService.capas = [];
    this.callbackService.isNeededCallback();
  }

}
